import React from 'react';
/**
 * Top level component for the Footer bar at the bottom of the app
 */
class ZuiFooter extends React.Component {
  render() {
    return (
      <zui-shell-footer unresolved>
        <div>&copy; 1995 - {new Date().getFullYear()} Zywave, Inc. All rights reserved.</div>
        <a
          className="zui-link"
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.zywave.com/terms-conditions/"
        >
          Terms and Conditions
        </a>
        <a
          className="zui-link"
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.zywave.com/privacy-statement/"
        >
          Privacy Statement
        </a>
        <a
          className="zui-link"
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.zywave.com/dmca-notice/"
        >
          DMCA
        </a>
        <a
          className="zui-link"
          target="_blank"
          rel="noopener noreferrer"
          href="http://www.zywave.com/cookie-usage/"
        >
          Cookie Usage
        </a>
        <a className="zui-link" href="mailto:support@zywave.com">
          Contact
        </a>
      </zui-shell-footer>
    );
  }
}

export default ZuiFooter;
